<template>
  <div class="af-panel" v-if="visible">
    <div class="af-panel__text mb-4">
      <b-icon
        icon-pack="fa"
        icon="smile"
        size="is-large"
        type="is-green"
        class="mr-2"
      ></b-icon>

      <div>
        <p class="is-size-5 has-text-weight-bold mb-2">
          {{ $t("af:offers.eligible_for_more.title") }}
        </p>

        <span>
          {{
            $t("af:offers.eligible_for_more.subtitle", {
              amount: monify(dtiCalc.amount),
            })
          }}
        </span>
      </div>
    </div>

    <div class="af-panel__actions">
      <b-button type="is-blue" class="has-text-weight-medium" @click="recalc"
        >{{
          $t("af:offers.eligible_for_more.button.show_me", {
            amount: monify(dtiCalc.amount),
          })
        }}
      </b-button>

      <span class="af-text-button has-text-grey-icon" @click="visible = false">
        {{ $t("af:offers.eligible_for_more.button.not_interested") }}
      </span>
    </div>
  </div>
</template>

<script>
import { monify } from "../utils/util";

export default {
  name: "EligibleForMoreLoan",
  data() {
    return {
      monify,
      visible: true,
    };
  },
  props: {
    dtiCalc: {
      type: Object,
      required: true,
    },
  },
  methods: {
    recalc() {
      this.$emit("recalc");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/colors.scss";

.af-panel {
  border-radius: 12px;
  padding: 20px;
  background: $green-1;
  border: 1px solid $green-2;

  &__text {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
  }

  &__actions {
    button,
    span {
      width: 100%;
      font-size: 0.8rem;
    }
  }
}

@media only screen and (min-width: 769px) {
  .af-panel {
    padding: 32px 36px;

    &__actions {
      button,
      span {
        width: unset;
        font-size: initial;
      }
    }
  }
}
</style>
